<template>
  <div
    id="modalPayMask"
    class="modal fade"
    data-backdrop="static"
    data-modal-location="home"
  >
    <div
      class="modal-dialog modal-dialog-vertical-center modal-md"
      role="document"
    >
      <div class="modal-content bd-0 tx-14">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t("outside.支付确认") }}
          </h6>
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body pd-25 model-auto-h">
          <div class="pay-mask">
            <div class="pay-wait-content">
              <p class="mg-b-30">
                {{
                  $t(
                    "outside.请在新打开的页面完成支付，支付完成前，请不要关闭此窗口。支付完成后请根据您的情况点击下面按钮：已完成支付"
                  )
                }}
              </p>
              <div class="tx-center mg-b-30">
                <button class="btn btn-info" @click="paySuccess(true)">
                  {{ $t("outside.已完成支付") }}
                </button>
              </div>
              <p class="tx-12">
                {{ $t("outside.支付遇到问题？联系客服获得帮助。") }}<br />
                <span class="tx-gray-700"
                  >({{ $t("outside.支付码：") }}{{ code }})</span
                >
                <a
                  class="tx-info"
                  target="_blank"
                  href="http://wpa.qq.com/msgrd?v=3&uin=236838202&site=www.5yoho.cn&menu=yes"
                >
                  <i class="fa fa-qq" aria-hidden="true"></i>
                  {{ $t("outside.在线咨询") }}
                </a>
              </p>
            </div>
          </div>
        </div>
        <div class="modal-footer tx-center">
          <button
            type="button"
            @click="paySuccess"
            class="
              btn btn-secondary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
          >
            {{ $t("outside.关闭") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ["code"],
  methods: {
    paySuccess() {
      this.$emit("pay_success");
    },
  },
};
</script>

<style scoped>
/*.pay-mask{
  position: fixed;
  top:0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, .6);
  z-index: 1042;
}
.pay-wait-content{
  position: fixed;
  top: 50%;
  left: 50%; 
  transform: translate(-50%, -50%);
  width: 500px;
  background-color: #fff;
  padding: 25px;
}
button.btn{
  cursor: pointer;
}*/
</style>
